import { componentWrapper } from "../../utilities";
import { LoadingOverlay as MantineLoadingOverlay } from "@mantine/core";
import styles from "./loading-overlay.module.scss";
import { LoadingOverlayFactory, IProps } from "./loading-overlay.types";

/**
 * Alert component for displaying important messages to users.
 * @param {React.ReactNode} props.children - The content to display in the alert.
 * @param {IconDefinition} props.icon - Optional icon to display in the alert.
 * @returns {JSX.Element} The Alert component.
 */
const LoadingOverlay = componentWrapper<LoadingOverlayFactory, IProps>("LoadingOverlay", (props, ref) => {
    return (
        <MantineLoadingOverlay
            ref={ref}
            classNames={{
                root: styles["root"],
                loader: styles["loader"],
                overlay: styles["overlay"],
            }}
            {...props}
        />
    );
});

export { LoadingOverlay };
